import { Injectable } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { Subscription } from "rxjs";
import { HTTPService } from "src/app/services/http.service";
import { UserAuthenticationServices } from "src/app/services/user-authentication.services";
import { ObjectUtil } from "src/app/system-utils/utils/ObjectUtil";
import { WebhookConfiguration, WebhookField } from "../webhook-interfaces/configuration";
import { FormServices } from "src/app/services/form.services";
import { NzMessageService } from "ng-zorro-antd/message";
import { Variable } from "src/app/forms/formula-tester/formula-tester.component";
import { FormulaServices } from "src/app/services/formula.service";
import { Flow } from "../webhook-interfaces/flow";
import { Version } from "../webhook-edit/webhook-edit.component";
import { FlowData } from "../webhook-interfaces/flowdata";
import { FileLoaderServices } from "src/app/services/FileLoader.services";
import { GlobalErrorHandler } from "src/app/services/GloabalErrorHandler.services";
import { LanguageServices } from "src/app/services/LanguageServices";
import { sequence } from "@angular/animations";

@Injectable({
  providedIn: 'root',
})

export class WebHookCommonServices {
    
    getDataLog(url: string) {
        return new Promise((resolve,reject)=>{
             let ob = {
                url: url
            }
            this.sub7 = this.http.post(ob,'FlowServices/getFlowData',false).subscribe({
                next:(va)=>{
                    resolve(va);
                },
                error:(error)=>{
                    reject(error);
                }
            });
        });
    }


    getDataLogRuntime(idjob: string, sequence: number) {
        return new Promise((resolve,reject)=>{
             let ob = {
                idjob: idjob,
                sequence: sequence,
                entity:'mktplgioff'
            }
            this.sub7 = this.http.post(ob,'FlowServices/getFlowDataById',false).subscribe({
                next:(va)=>{
                    resolve(va);
                },
                error:(error)=>{
                    reject(error);
                }
            });
        });
    }
    
    exportFlow(expression:Flow, selectedVersion:Version, flowData:FlowData) {
        const text = expression ?? '';
        try {
            // Valida JSON antes da exportação
            let json = JSON.stringify(expression, null, 2);
            
            const blob = new Blob([json], { type: 'application/json' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `export-flow-${flowData.idconf}-${selectedVersion.sequence}-${new Date(Date.now()).toISOString()}.json`;
            link.click();
            window.URL.revokeObjectURL(url);
            
            this.messageService.success(this.ts.instant('workflow.export.success'));
        } catch (error) {
            this.messageService.error(this.ts.instant('workflow.export.error',{error:error}));
        }
    }

    importFlow(){
        this.fls.loadFileOpener(null,null);
    }
    

    openFormula(formula:string, variables:Variable[], form?:FormGroup|FormControl, fieldName?:string){

        this.formulaServices.openFormula(formula,variables).then(formula=>{
                if ( form != null  ){
                    if ( form instanceof FormControl ){
                        form.setValue(formula);
                    }else{
                        if ( fieldName != null ){
                            form.get(fieldName).setValue(formula);
                        }
                    }
                }
        });
    }
  
    stopFlow(threadName: string) {
        return new Promise((resolve,reject)=>{
             let ob = {
                threadName: threadName
            }
            this.sub7 = this.http.post(ob,'FlowServices/stopFlow',false).subscribe({
                next:(va)=>{
                    resolve(va);
                },
                error:(error)=>{
                    reject(error);
                }
            });
        });
    }
    
    continueFlow(idjob: number, key:string) {
          return new Promise((resolve,reject)=>{
            let ob = {
                idjob: idjob,
                key:key
            }
            this.sub7 = this.http.post(ob,'FlowServices/continue',false).subscribe({

                next:(va)=>{
                    resolve(va);
                },
                error:(error)=>{
                    reject(error);
                }

            });
        });
    }
    
    startFlow(idconf, codeCompany, sequence) {

        return new Promise((resolve,reject)=>{
            let ob = {
                idconf: idconf,
                codecompany: codeCompany,
                sequence: sequence
            }
            this.sub7 = this.http.post(ob,'FlowServices/startFlow',false).subscribe({

                next:(va)=>{
                    resolve(va);
                },
                error:(error)=>{
                    reject(error);
                }

            });
        });
        
    }
    
    removeVariable(condition: string) {
        return new Promise((resolve,reject)=>{
            let ob = {
                entityName:'Mktpcontractpref',
                condition: condition
            }
            this.sub6 = this.http.post(ob,'JsonBrokerServices/remove',false).subscribe(
                {
                    next:(data)=>resolve(true),
                    error:(erro)=>reject(erro)
                }
            )
        });
    }


    removeGeneric(condition: string, entityName:string) {
        return new Promise((resolve,reject)=>{
            let ob = {
                entityName:entityName,
                condition: condition
            }
            this.sub6 = this.http.post(ob,'JsonBrokerServices/remove',false).subscribe(
                {
                    next:(data)=>resolve(true),
                    error:(erro)=>reject(erro)
                }
            )
        });
    }
    

    sub2:Subscription;
    sub1:Subscription;
    sub3: Subscription;
    sub5: Subscription;
    sub6: Subscription;
    sub7: Subscription;

    onDestroy(): void {
        if (this.sub2) {
            this.sub2.unsubscribe();
        }

        if (this.sub6) {
            this.sub6.unsubscribe();
        }

        if ( this.sub1 ){
            this.sub1.unsubscribe();
        }

        if ( this.sub3 ){
            this.sub3.unsubscribe();
        }

        if ( this.sub5 ){
            this.sub5.unsubscribe();
        }

        if ( this.sub7 ){
            this.sub7.unsubscribe();
        }

    }

    cancelLoading(){
        if ( this.sub1!= null ){
            this.sub1.unsubscribe();
        }
    }

    constructor(private http:HTTPService, private ts:LanguageServices, private fb:FormBuilder,
        private messageService: NzMessageService, private fs:FormServices,private formulaServices:FormulaServices,
        private fls:FileLoaderServices
            
    ) {
    
    }

    saveFlow(ob:object): Promise<any> {
        
        return new Promise((resolve,reject)=>{
            this.sub3 = this.http.post(ob,'JsonBrokerServices/save',false,true,true).subscribe(
            {
                next: (res:any) => {
                    resolve(res);
                },
                error: (error:any) => {
                    reject(error);
                }
            });

        });
    }

    loadFlow(idconf:number): Promise<any> {

        return new Promise((resolve,reject)=>{
                
              let buscaName = {
                  "entityName":"Mktpcfi",
                  "sql":`SELECT EXPRESSION,SEQUENCE,ACTIVE,DTFORCE,RECMODIFYON, 
                            CASE WHEN ACTIVE ='S' AND DTFORCE IS NOT NULL THEN 1
                                 WHEN ACTIVE ='N' AND DTFORCE IS NOT NULL THEN -1
                                    ELSE 0 END AS ORDERDATA,
                                    NAME
                        FROM MKTPCFI
                        WHERE IDCONF = ${idconf}
                        AND EXPRESSION IS NOT NULL
                        ORDER BY ORDERDATA DESC, SEQUENCE DESC
                        `            
                };
            
                this.sub2 = this.http.post(buscaName,'JsonBrokerServices/findnative',false,true,true).subscribe({
                    next: (res:any) => {
                        if( ObjectUtil.isNotEmpty(res['SQL'])){
                            resolve(res['SQL']);
                        }else {
                            resolve([]);
                        }
                    },
                    error: (error:any) => {
                        reject(error);
                    }
                }
            );
        });
    }

    findGeneric(pageIndex:number, pageSize:number, sortField:string, sortOrder:string, filter:Array<{ key: string; value: string[] }>, entityName:string): Promise<any> {
        let ob = {
            "entityName":entityName,
            "showPresentation":true,
            "showRelationshipData":false,
            "showRelationship":false,
            "showTableInformation":false,
            "rows": pageSize,
            "fetchSize": pageIndex
        }
        
        if ( filter.length > 0 ){
            let filterStr =  this.mountFilter(filter);
            ob['condition'] = filterStr;
        }

        return new Promise((resolve,reject)=>{
                
                this.sub2 = this.http.post(ob,'JsonBrokerServices/find',false,true,true).subscribe({
                    
                    next: (res:any) => {

                        if( ObjectUtil.isNotEmpty(res)){
                            resolve(res);
                        }else {
                            resolve([]);
                        }
                    },
                    error: (error:any) => {
                        reject(error);
                    }
                }
            );
        });
    }

    findContractPref(pageIndex:number, pageSize:number, sortField:string, sortOrder:string, filter:Array<{ key: string; value: string[] }>): Promise<any> {

        let ob = {
            "entityName":"Mktpcontractpref",
            "showPresentation":true,
            "showRelationshipData":false,
            "showRelationship":false,
            "showTableInformation":false,
            "rows": pageSize,
            "fetchSize": pageIndex
        }
        
        if ( filter.length > 0 ){
            let filterStr =  this.mountFilter(filter);
            ob['condition'] = filterStr;
        }

        return new Promise((resolve,reject)=>{
                
                this.sub2 = this.http.post(ob,'JsonBrokerServices/find',false,true,true).subscribe({
                    
                    next: (res:any) => {

                        if( ObjectUtil.isNotEmpty(res)){
                            resolve(res);
                        }else {
                            resolve([]);
                        }
                    },
                    error: (error:any) => {
                        reject(error);
                    }
                }
            );
        });
    }


    mountFilter(filter: { key: string; value: string[]; }[]) {
        let condition = '';
        let i = 0 ;
        for ( let line of filter){
            
            if ( i == 0 ){
                if ( typeof line.value === 'string' ){
                    condition = condition +' ' + line.key + ' LIKE \'%'+line.value+ '%\'';
                }else{
                    if ( typeof line.value === 'object' ){
                        if ( line.value instanceof Date){
                            condition = condition +' ' + line.key + " >= '"+line.value.toISOString().substring(0,19).replace('T',' ')+"'";
                        }else{
                            condition = condition +' ' + line.key + ' = '+line.value;    
                        }
                    }else{
                        condition = condition +' ' + line.key + '='+line.value ;
                    }
                    
                }
            }else{
                if ( typeof line.value === 'string' ){
                    condition = condition +' AND ' + line.key + ' LIKE \'%'+line.value+ '%\'';
                }else{
                    if ( typeof line.value === 'object' ){
                        if ( line.value instanceof Date){
                            condition = condition +' AND ' + line.key + " >= '"+line.value.toISOString().substring(0,19).replace('T',' ')+"'";
                        }else{
                            condition = condition +' AND ' + line.key + ' = '+line.value;    
                        }
                    }else{
                        condition = condition +' AND ' + line.key + ' = '+line.value;
                    }
                }
            }
            i++;
        }
        return condition;
    }

    loadConfigurations() {
        
        return new Promise((resolve,reject)=>{
            let buscaconfig = {
                "entityName":"Mktpcfi",
                "sql":`SELECT NAME,TEXT
                        FROM MKTPPREF
                        WHERE NAME LIKE 'flow.form%'`            
            };
        
            this.sub1 = this.http.post(buscaconfig,'JsonBrokerServices/findnative',false,true,true).subscribe(
            {
                next: (con:any) => {
                    if( ObjectUtil.isNotEmpty(con['SQL'])){
                        resolve(con['SQL']);
                    } else {
                        reject([]);
                    }
                },
                error: (error:any) => {
                    reject(error);
                }
            });
                
        });
    }


    createVarible(newRow: FormGroup<any>) {

        let object = newRow.getRawValue();
        object['entityName'] = 'Mktpcontractpref';
        

        return new Promise((resolve,reject)=>{
            this.sub5 = this.http.post(object,'JsonBrokerServices/save',false,true,true).subscribe(
            {
                next: (res:any) => {
                    resolve(res);
                },
                error: (error:any) => {
                    reject(error);
                }
            });

        });
    }


    createGeneric(newRow: FormGroup<any>, entityName:string) {

        let object = newRow.getRawValue();
        object['entityName'] = entityName;
        

        return new Promise((resolve,reject)=>{
            this.sub5 = this.http.post(object,'JsonBrokerServices/save',false,true,true).subscribe(
            {
                next: (res:any) => {
                    resolve(res);
                },
                error: (error:any) => {
                    reject(error);
                }
            });

        });
    }


    loadLogByIdJob(
        id:string){
        
        return new Promise((resolve,reject)=>{            
            let buscaLog = {
                id: id
            }
                this.sub1 = this.http.post(buscaLog,'FlowServices/loadLogById',false,true,true).subscribe(
                {
                    next: (con:any) => {
                        if( ObjectUtil.isNotEmpty(con['SQL'])){
                            if ( con['SQL']){
                                resolve(con['SQL'][0]);
                            }else{
                                resolve([]);    
                            }
                        } else {
                            resolve([]);
                        }
                    },
                    error: (error:any) => {
                        reject(error);
                    }
                });
        });
    }

    loadLog(
        idconf:number,
        pageIndex: number,
        pageSize: number,
        sortField: string | null,
        sortOrder: string | null,
        filter: Array<{ key: string; value: string[]}>,
        uas:UserAuthenticationServices ){
        
        return new Promise((resolve,reject)=>{            
            let buscaLog = {
                pageSize: pageSize,
                pageIndex: pageIndex,
                idconf: idconf,
                companies: uas.getCompanies(),
                filters: filter,
                sortField: sortField,
                sortOrder: sortOrder
                }
                this.sub1 = this.http.post(buscaLog,'FlowServices/loadLog',false,true,true).subscribe(
                {
                    next: (con:any) => {
                        if( ObjectUtil.isNotEmpty(con['SQL'])){
                            resolve(con['SQL']);
                        } else {
                            resolve([]);
                        }
                    },
                    error: (error:any) => {
                        reject(error);
                    }
                });
        });
    }
    
    getOrder(sortField: string, sortOrder: string) {
        if ( sortField == null){
            return "IDJOB DESC"
        }else{
            if ( sortOrder !=''){
                let order = sortField + " " + (sortOrder === 'ascend'? 'ASC' : ' DESC ') ;
                return order;
            }
            
        }
    }
 
    
    createControl(each:WebhookField, form:FormGroup){
    
        let stringControls:string[] = each.field.split(".");
        let currentGroup = form;

        for ( let i = 0; i < stringControls.length; i++){
            const key = stringControls[i];
            if (i === stringControls.length - 1) {
                this.createDetailControl(each,currentGroup,key);
            }else{
                if (!currentGroup.get(key)) {
                    currentGroup.addControl(key, this.fb.group({}));
                }
                currentGroup = currentGroup.get(key) as FormGroup;
            }
        }
    }

    extractTaggedFieldPaths(fields: WebhookField[], currentPath: string[] = []): { path: string, field: WebhookField }[] {
        const results: { path: string, field: WebhookField }[] = [];

        for (const field of fields) {
            const newPath = [...currentPath, field.field];

            if (field.field) {
                results.push({ path: newPath.join("."), field });
            }

            const nestedFields =
            field.sectionConfiguration?.fields ||
            field.tableConfiguration?.fields

            if (nestedFields) {
                results.push(...this.extractTaggedFieldPaths(nestedFields, newPath));
            }
        }

        return results;
    }
    
    createDetailControl( each:WebhookField, form:FormGroup, name:string){
        if ( each.type!='divider' && each.type!='button' && each.type!='component'){
            if ( each.type == "keyValue" ||  each.type=="simpletable" ||  each.type=="table"){
                var formArray = this.fb.array([]);
                form.addControl(name,formArray);
            }else{
                if ( each.type == "keyValueObject" || each.type == "section"){
                    form.addControl(name,this.fb.group({}));
                }else{
                    if ( each.type == "tag"){
                        var controlTag = new FormControl([])
                        form.addControl(name,controlTag);
                    }else{
                        var formControl = new FormControl();
                        if ( each.required ){
                            formControl.addValidators(Validators.required);
                        }
                        if ( each.maxLength != null && each.maxLength > 0 ){
                            formControl.addValidators(Validators.maxLength(each.maxLength));
                        }
                        if ( each.minLength != null && each.minLength > 0 ){
                            formControl.addValidators(Validators.minLength(each.minLength));
                        }
                        if ( each.validation != null ){
                            formControl.addValidators(Validators.pattern(each.validation.pattern));
                        }
                        if ( each.isDisabled ){
                            formControl.disable();
                        }

                        if ( each.defaultValue != null ){
                            formControl.patchValue(each.defaultValue);
                        }

                        form.addControl(name, formControl);
                    }
                }
            }
        }
    }
    
    showError(fields:WebhookField[], form:FormGroup): void {

        this.messageService.error("<br/><br/>"+this.fs.getFormErrors(form,fields,"<br/>"));
        
        Object.values(form.controls).forEach(control => {
                if (control.invalid) {
                    control.markAsDirty();
                    control.updateValueAndValidity({ onlySelf: true });
                }
        });
    }

    showErrorSimple(message:string): void {
        this.messageService.error(this.ts.instant(message));
    }

    showSuccessSimple(message:string): void {
        this.messageService.success(this.ts.instant(message));
    }

    refreshForms(properties: object, form: FormGroup) {
        this.fs.patchForm(properties,form);
    }

    getDataNativeQuery(query:string,variables:Variable[]){
        let ob = {
        "entityName":"Mktpquery",
        "sql":this.applyVariables(query,variables)
      }
       
      return new Promise((resolve, reject)=>{
        this.http.post(ob,'JsonBrokerServices/findnative',false,true,true).subscribe({
            next:  (data)=>{
            if ( data['SQL']){
                resolve(data['SQL']);
            }
            },
            error: (error)=>{
                reject(error);
            }
        });
      });
  }

  public applyVariables(condition: string,variables:Variable[]) {
    
    let regex = new RegExp(/{@(.*?)}/g);
    var match;

    while ((match = regex.exec(condition)) !== null) {
      let variable:string = match[0];
      let workVariable:string =  variable.replace("{", "").replace("}", "").toUpperCase();
      
      var dataVariable:Variable = variables.find(d=>d.key.toUpperCase() == workVariable);
      
      if ( dataVariable != null  ){
        let toReplace = dataVariable.value;
        condition = condition.replace(variable,toReplace);
      }
    }

    return condition;
  } 


    getThreads() {

        return new Promise((resolve,reject)=>{
            this.http.post({},'SystemServices/threads',false,true,true,false).subscribe({
                next:(data)=>{
                    resolve(data);
                },
                error:(error)=>{
                    reject(error);
                }
            });
        });
    }


    getThreadsId(thread) {

        return new Promise((resolve,reject)=>{
            this.http.post({},'SystemServices/threadInfo',false,true,true,false).subscribe({
                next:(data)=>{
                    resolve(data);
                },
                error:(error)=>{
                    reject(error);
                }
            });
        });
    }


    loadStatus(idJob: any) {
        return new Promise((resolve,reject)=>{
            let ob = {
                idjob: idJob
            }
            this.http.post(ob,'FlowServices/log', false,true,true,false).subscribe({
                next:(va)=>{
                    resolve(va);
                },
                error:(error)=>{
                    reject(error);
                }
            });

        });
    }
    
}